import { useQuery } from "@tanstack/react-query"
import { tagsQuery } from "../lib/tagsQuery"

export function useTagsQuery() {
  return useQuery(tagsQuery())
}
